import { Injectable } from '@angular/core';
import { AlertController, ToastController, LoadingController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class GlobalService {

    public static FirebaseUser = null;
    public static Token = null;
    public static CURRENT = null;

    public static JSON_WEAPONS = null;
    public static JSON_ARMOR = null;
    public static JSON_CYBERWARE = null;
    public static JSON_GEAR = null;
    public static JSON_LIFEPATH = null;
    public static JSON_PROGRAMS = null;

    public static JSON_SHEET = null;

    public static UUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    public static CHARACTER = GlobalService.EmptyCharacter();
    constructor(private alertController: AlertController, private toastController: ToastController, private loadingController: LoadingController) {

    }
    public static EmptyCharacter()
    {
        return {
            UID: null,
            version: "JumpStartKit",
            name: "John Doe",
            avatar: "assets/images/avatar.png",
            role: "Solo",
            statAllocation: "Random",
            statDice: [],
            statPoints: 40,
            statPointsAllocation: 40,
            skillPoints: 34,
            skillPointsAllocation: 34,
            weapons: [],
            armor: [],
            cyberware: [],
            gear: [],
            programs:[],
            story: "",
            notes: "",
            lifepath: {
                background: "",
                motivation: "",
                goals: "",
                friends: [],
                enemies: [],
                personality: "",
                romance: ""

            },
            stats: {
                INT: { value: 2, min: 2, max: 10, set: false },
                REF: { value: 2, min: 2, max: 10, set: false },
                DEX: { value: 2, min: 2, max: 10, set: false },
                TECH: { value: 2, min: 2, max: 10, set: false },
                COOL: { value: 2, min: 2, max: 10, set: false },
                WILL: { value: 2, min: 2, max: 10, set: false },
                LUCK: { value: 2, min: 2, max: 10, set: false },
                MOVE: { value: 2, min: 2, max: 10, set: false },
                BODY: { value: 2, min: 2, max: 10, set: false },
                EMP: { value: 2, min: 2, max: 10, set: false }
            },
            skills: [
                { name: "Perception", stat: "INT", value: 2, roles: [] },
                { name: "Tracking", stat: "INT", value: 0, roles: [] },
                { name: "Education", stat: "INT", value: 2, roles: [] },
                { name: "Local Expert", stat: "INT", value: 2, roles: [] },
                { name: "Marksmanship", stat: "REF", value: 0, roles: [] },
                { name: "Driving", stat: "REF", value: 0, roles: [] },
                { name: "Evasion", stat: "DEX", value: 0, roles: [] },
                { name: "Athletics", stat: "DEX", value: 2, roles: [] },
                { name: "Stealth", stat: "DEX", value: 0, roles: [] },
                { name: "Brawling", stat: "DEX", value: 0, roles: [] },
                { name: "Melee Weapon", stat: "DEX", value: 0, roles: [] },
                { name: "Basic Tech", stat: "TECH", value: 0, roles: [] },
                { name: "CyberTech", stat: "TECH", value: 0, roles: [] },
                { name: "First Aid", stat: "TECH", value: 0, roles: [] },
                { name: "Bribery", stat: "COOL", value: 0, roles: [] },
                { name: "Interrogation", stat: "COOL", value: 0, roles: [] },
                { name: "Persuasion", stat: "COOL", value: 2, roles: [] },
                { name: "Concentration", stat: "WIL", value: 2, roles: [] },
                { name: "Conversation", stat: "WIL", value: 0, roles: [] },
                { name: "Human Perception", stat: "WIL", value: 0, roles: [] },
                { name: "Play Instrument", stat: "WIL", value: 0, roles: [] },
                { name: "Interface", stat: "-", value: 0, roles: ["Netrunner"] },
            ]
        }
    }
    public static ResetCharacter() {
        var char = this.EmptyCharacter();
        GlobalService.CHARACTER.UID = char.UID;
        GlobalService.CHARACTER.version = char.version;
        GlobalService.CHARACTER.name = char.name;
        GlobalService.CHARACTER.role = char.role;
        GlobalService.CHARACTER.role = char.role;
        GlobalService.CHARACTER.avatar = char.avatar;
        GlobalService.CHARACTER.statAllocation = char.statAllocation;
        GlobalService.CHARACTER.statDice = char.statDice;
        GlobalService.CHARACTER.statPoints = char.statPoints;
        GlobalService.CHARACTER.statPointsAllocation = char.statPointsAllocation;
        GlobalService.CHARACTER.skillPoints = char.skillPoints;
        GlobalService.CHARACTER.skillPointsAllocation = char.skillPointsAllocation;
        GlobalService.CHARACTER.weapons = char.weapons;
        GlobalService.CHARACTER.programs = char.programs;
        GlobalService.CHARACTER.armor = char.armor;
        GlobalService.CHARACTER.cyberware = char.cyberware;
        GlobalService.CHARACTER.gear = char.gear;
        GlobalService.CHARACTER.story = char.story;
        GlobalService.CHARACTER.notes = char.notes;
        GlobalService.CHARACTER.lifepath.background = char.lifepath.background;
        GlobalService.CHARACTER.lifepath.motivation = char.lifepath.motivation;
        GlobalService.CHARACTER.lifepath.goals = char.lifepath.goals;
        GlobalService.CHARACTER.lifepath.friends = char.lifepath.friends;
        GlobalService.CHARACTER.lifepath.enemies = char.lifepath.enemies;
        GlobalService.CHARACTER.lifepath.personality = char.lifepath.personality;
        GlobalService.CHARACTER.lifepath.romance = char.lifepath.romance;
        GlobalService.CHARACTER.stats = char.stats;
        GlobalService.CHARACTER.skills = char.skills;

        if (GlobalService.CHARACTER.statDice == null) { GlobalService.CHARACTER["statDice"] = []; }

        if (GlobalService.CHARACTER.weapons == null) { GlobalService.CHARACTER["weapons"] = []; }
        if (GlobalService.CHARACTER.programs == null) { GlobalService.CHARACTER["programs"] = []; }
        if (GlobalService.CHARACTER.armor == null) { GlobalService.CHARACTER["armor"] = []; }
        if (GlobalService.CHARACTER.cyberware == null) { GlobalService.CHARACTER["cyberware"] = []; }
        if (GlobalService.CHARACTER.gear == null) { GlobalService.CHARACTER["gear"] = []; }
        if (GlobalService.CHARACTER.lifepath.friends == null) { GlobalService.CHARACTER.lifepath.friends = []; }
        if (GlobalService.CHARACTER.lifepath.enemies == null) { GlobalService.CHARACTER.lifepath.enemies = []; }

        for (var i = 0; i < GlobalService.CHARACTER.skills.length; i++) {
            if (GlobalService.CHARACTER.skills[i].roles == null) { GlobalService.CHARACTER.skills[i]["roles"] = []; }
        }
    }
    public static getAllocationMethod() {
        var m = GlobalService.CHARACTER.statAllocation;
        var method = GlobalService.StatAllocationMethods.filter(e => { return e.name == m; });
        if (method.length > 0) {
            return method[0];
        }
        return null;
    }
    public static ResetStats() {
        for (var i = 0; i < this.Stats.length; i++) {
            var statname = this.Stats[i];
            this.CHARACTER.stats[statname].value = 2;
            this.CHARACTER.stats[statname].set = false;
           
        }
    }
    public static ResetSkills() {
        for (var i = 0; i < this.CHARACTER.skills.length; i++) {
            this.CHARACTER.skills[i].value = 0;
        }
    }
    public static StatAllocationMethods = [
        { name: "Random", description: "Roll 10D10, you have this many Character Points, assign from 2 to 10 (we will already assign the minimum value for each stat)", buttontext: "Reroll", input: false,points:0,change:true },
        { name: "Fast", description: "Roll 1D10 for each stat, rerolling 1's and 2's, Place Rolls in each stat as desired", buttontext: "Reroll", input: false, points: 0, change: false },
        { name: "Major Hero", description: "You have a total of 80 points to distribute, min 2, max 10 (we will already assign the minimum value for each stat)", buttontext: "", input: false, points: 80, change: true },
        { name: "Major Supporting Hero", description: "You have a total of 70 points to distribute, min 2, max 10 (we will already assign the minimum value for each stat)", buttontext: "", input: false, points: 70, change: true },
        { name: "Minor Hero", description: "You have a total of 75 points to distribute, min 2, max 10 (we will already assign the minimum value for each stat)", buttontext: "", input: false, points: 75, change: true },
        { name: "Minor Supporting Hero", description: "You have a total of 60 points to distribute, min 2, max 10 (we will already assign the minimum value for each stat)", buttontext: "", input: false, points: 60, change: true },
        { name: "Average", description: "You have a total of 50 points to distribute, min 2, max 10 (we will already assign the minimum value for each stat)", buttontext: "", input: false, points: 50, change: true },
        { name: "Custom", description: "Set the available points to distribute", buttontext: "", input: true, points: 0, change: true }
    ];
    public static Stats = ["INT","REF","DEX","TECH","COOL","WILL","LUCK","MOVE","BODY","EMP"];
    public static Roles = [
        { name: "Rockerboy", description: "Rock and roll rebels who use performance and rhetoric to fight authority.", skills: [] },
        { name: "Solo", description: "Assassins, bodyguards, killers, and soldiers for hire in a lawless new world.", skills: [] },
        { name: "Netrunner", description: "Cybernetic master hackers of the post-NET world and brain burning secret stealers.", skills: [] }, 
        { name: "Tech", description: "Renegade mechanics and doctors patching up meat and metal alike.", skills: [] },
        { name: "Media", description: "Newsmen, media stars, and social influencers risking it all for the truth.", skills: [] },
        { name: "Lawman", description: "Maximum lawmen patrolling the mean streets and road warrior highways beyond.", skills: [] },
        { name: "Execs", description: "Corporate power brokers and business raiders fighting to restore the rule of the Megacorps.", skills: [] },
        { name: "Fixer", description: "Deal makers, smugglers, organizers, and information brokers on the post-war streets of the future.", skills: [] },
        { name: "Nomad", description: "Transportation experts and ultimate road warriors.", skills: [] },
    ];

    public static Init() {

    }

    public async showAlert(msg, title = "Ooops") {
        const alert = await this.alertController.create({
            header: title,
            message: msg,
            buttons: ['OK']
        });
        await alert.present();
    }
    public async showConfirm(title = "Confirm", msg = "Yes/No", btnCancel = "Cancel", btnOk = "Okay") {
        return new Promise(async (resolve) => {
            const alert = await this.alertController.create({
                header: title,
                message: msg,
                buttons: [
                    {
                        text: btnCancel,
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: (blah) => {
                            return resolve(false);
                        }
                    }, {
                        text: btnOk,
                        handler: () => {
                            return resolve(true);
                        }
                    }
                ]
            });

            await alert.present();
        });
    }


    async toast(msg, duration = 2000) {
        const t = await this.toastController.create({
            message: msg,
            duration: duration
        });
        t.present();
    }

    public static Roll(sides) {
        return (Math.floor(Math.random() * Math.floor(sides)) + 1) ;
    }
}
